module.exports = __webpack_public_path__ + "static/media/7.9672b3a4.JPG";